/* COOODEX Partner-Portal — Mini JS */
(function(){
  const modal = document.getElementById('s5-modal');
  if (modal) {
    document.querySelectorAll('[data-open-s5]').forEach(btn => {
      btn.addEventListener('click', () => {
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
      });
    });

    document.querySelectorAll('[data-close-s5]').forEach(btn => {
      btn.addEventListener('click', () => modal.close());
    });
  }
})();
